function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { PricingAudience, IAvailabilityActions } from '@shared/Models';
import { getTermPriorityForSorting } from '@shared/utils/pricing';
import { getWindow } from '@shared/services/window';
import { Constants } from '@shared/utils/constants';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { logger } from '@src/logger';
export class Product {
    populateTermsByPlanIdMap() {
        // Populates terms by planId
        this.plans.forEach((plan)=>{
            const tempPlanTerms = [];
            this.termsByPlanId[`${plan.planId}`] = [];
            /** Meters are unused yet, but is preparation for the future when AppSource would contain apps with custom meters */ this.metersByPlanId[`${plan.planId}`] = [];
            plan.availabilities.forEach((a)=>{
                tempPlanTerms.push(...a.terms);
                /** Meters are unused yet, but is preparation for the future when AppSource would contain apps with custom meters */ this.metersByPlanId[`${plan.planId}`].push(a.meter);
            });
            const unsortedTerms = tempPlanTerms.reduce((accumulatedArray, curr)=>{
                // in Professional Service offer type the renewTermUnit can be null
                if (this.isProfessionalService && !curr.renewTermId) {
                    curr.renewTermId = curr.termId;
                }
                // Iterate over all non-free trial terms (termId===renewTermId)
                if (curr.renewTermId === curr.termId) {
                    let freeTrialTermId = '';
                    let freeTrialTermUnit;
                    // Find relevant free trial term for specific termId
                    const freeTrialTerm = tempPlanTerms.find((term)=>term.renewTermId === curr.termId && term.renewTermId !== term.termId);
                    // Populate free trial info for term
                    if (freeTrialTerm) {
                        freeTrialTermId = freeTrialTerm.termId;
                        freeTrialTermUnit = freeTrialTerm.termUnits;
                    }
                    // Only added if non-free trial. Meaning we have a merged term with both freeTrial termId as well as non-free trial termId
                    accumulatedArray.push(_object_spread_props(_object_spread({}, curr), {
                        freeTrialTermId,
                        freeTrialTermUnit
                    }));
                }
                return accumulatedArray;
            }, []);
            this.termsByPlanId[`${plan.planId}`] = this.sortTermPrices(unsortedTerms);
        });
    }
    /** Extract all unique terms durations of product. Relies on renewTermId rather than termId */ populateUniqueTermsPerPlan() {
        this.plans.forEach((plan)=>{
            const uniqueTerms = [];
            const termsOfAllAvailabilitiesByPlan = plan.availabilities.map((avail)=>avail.terms);
            termsOfAllAvailabilitiesByPlan.forEach((terms)=>{
                terms.forEach((term)=>{
                    // in Professional Service offer type the renewTermUnit can be null
                    if (this.isProfessionalService && !term.renewTermUnits) {
                        term.renewTermUnits = term.termUnits;
                    }
                    if (!uniqueTerms.includes(term.renewTermUnits)) {
                        uniqueTerms.push(term.renewTermUnits);
                    }
                });
            });
            this.TermsPerPlanMapping[plan.planId] = uniqueTerms;
        });
    }
    constructor({ legacyId, bigId, plans, offerType }){
        /** List of term duration  */ _define_property(this, "TermsPerPlanMapping", {});
        /** Equivalent to entityId <PublisherId.OfferId> */ _define_property(this, "legacyId", void 0);
        _define_property(this, "bigId", void 0);
        _define_property(this, "plans", void 0);
        _define_property(this, "isProfessionalService", void 0);
        _define_property(this, "offerType", void 0);
        _define_property(this, "termsByPlanId", {});
        /** This is unused yet, but is preparation for the future when AppSource would contain apps with custom meters */ _define_property(this, "metersByPlanId", {});
        /**
   * Extract a specific availability from the plan's availabilities
   * The termId depends on the plan, and availability properties: termUnits (P1Y, month, ...), free trial and billing plan;
   */ _define_property(this, "getPlanAvailabilityByTermId", (planId, termId)=>{
            try {
                // Get the selected plan
                const plan = this.plans.find((plan)=>plan.planId === planId);
                // AppsSource only has direct commercial customers (no CSP or special type pricingAudience).
                // There should *always* be availabilities at this point since we filter by billing region prior to fetching the item
                const directAvailabilities = (plan.availabilities || []).filter((availability)=>availability.pricingAudience === PricingAudience.DirectCommercial && availability.actions.includes(IAvailabilityActions.Browse));
                // Filter by term, there could be multiple billingPlans with the same duration (termUnits) so this could still be an array
                return directAvailabilities.find((availability)=>availability.terms.some((term)=>term.termId === termId)) || {};
            } catch (error) {
                const payload = {
                    page: getWindow().location.href,
                    action: Constants.Telemetry.Action.Checkout,
                    actionModifier: Constants.Telemetry.ActionModifier.Error,
                    appName: this.legacyId,
                    details: JSON.stringify({
                        error,
                        plansId: this.plans.map(({ planId })=>planId),
                        planId,
                        termId
                    })
                };
                SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
                logger.error(payload.details, {
                    action: payload.action,
                    actionModifier: payload.actionModifier,
                    appName: payload.appName
                });
                throw error;
            }
        });
        /** Extract default availability by planId */ _define_property(this, "getFirstTermFromPlan", (planId)=>{
            var _this_termsByPlanId_;
            return (_this_termsByPlanId_ = this.termsByPlanId[`${planId}`]) === null || _this_termsByPlanId_ === void 0 ? void 0 : _this_termsByPlanId_[0];
        });
        /** Returns the distinct of possible term durations by planId */ _define_property(this, "getTermDurationsByPlanId", (planId)=>{
            return this.TermsPerPlanMapping[`${planId}`];
        });
        /** Helper method to get selected plan by planId rather than access plans array by index */ _define_property(this, "getPlanByPlanId", (targetPlanId)=>{
            const plan = this.plans.find((plan)=>plan.planId === targetPlanId);
            return plan;
        });
        /** Used to get terms entity by termId. TermId should be the renew termId  */ _define_property(this, "getFirstTermByPlanId", (planId)=>{
            var _this_termsByPlanId_;
            return (_this_termsByPlanId_ = this.termsByPlanId[`${planId}`]) === null || _this_termsByPlanId_ === void 0 ? void 0 : _this_termsByPlanId_[0];
        });
        /** Used to get terms entity by termId. TermId should be the renew termId  */ _define_property(this, "getTermByTermId", ({ planId, termId })=>{
            return this.termsByPlanId[`${planId}`].find((term)=>{
                // Compare the given termId with either the free trial termId or non free trial termId
                const foundTerm = termId === term.termId || termId === term.freeTrialTermId;
                return foundTerm;
            });
        });
        /** Returns a new array of ascending sorted term prices. First by billing term and if the billing terms are equal then by the billing period frequency */ _define_property(this, "sortTermPrices", (termPrices)=>{
            if (!(termPrices === null || termPrices === void 0 ? void 0 : termPrices.length)) {
                return [];
            }
            // Cloning before calling ".sort" is a must because ".sort" sorts the array in-place.
            return [
                ...termPrices
            ].sort((a, b)=>{
                if (a.renewTermUnits === b.renewTermUnits) {
                    var _a_billingPlan, _b_billingPlan;
                    return getTermPriorityForSorting((_a_billingPlan = a.billingPlan) === null || _a_billingPlan === void 0 ? void 0 : _a_billingPlan.billingPeriod) - getTermPriorityForSorting((_b_billingPlan = b.billingPlan) === null || _b_billingPlan === void 0 ? void 0 : _b_billingPlan.billingPeriod);
                }
                return getTermPriorityForSorting(a.renewTermUnits) - getTermPriorityForSorting(b.renewTermUnits);
            });
        });
        _define_property(this, "getTermByPlanAndBillingTermDuration", ({ planId, billingTermDuration })=>{
            var _this_termsByPlanId__filter;
            return (_this_termsByPlanId__filter = this.termsByPlanId[`${planId}`].filter((term)=>term.renewTermUnits === billingTermDuration)) === null || _this_termsByPlanId__filter === void 0 ? void 0 : _this_termsByPlanId__filter[0];
        });
        this.legacyId = legacyId;
        this.bigId = bigId;
        this.plans = plans;
        this.offerType = offerType;
        this.isProfessionalService = plans.some(({ isHiddenPrivateOffer })=>isHiddenPrivateOffer);
        this.populateTermsByPlanIdMap();
        this.populateUniqueTermsPerPlan();
    }
}
